// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*[data-v-0efe3ae6]{padding:0;margin:0}body[data-v-0efe3ae6]{font-family:sans-serif;width:100%;text-align:center}svg[data-v-0efe3ae6]{width:40%;max-width:400px}svg .st0[data-v-0efe3ae6]{fill:#3d4659}#content[data-v-0efe3ae6]{padding:2vh;display:inline-block;max-width:1024px;margin:0 auto;text-align:left}h1[data-v-0efe3ae6]{margin:1.4rem 0}p[data-v-0efe3ae6]{margin-bottom:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
